import {createActions} from 'redux-actions';
import fetchJson from '../fetchJson';
import {push} from 'connected-react-router';
import handleError from '../handleError';

const actions = createActions(
	'SUGGESTIONS_STARTED',
	'SUGGESTIONS_STOPPED',
	'SUGGESTIONS_LOADED',
	'SUGGESTIONS_NEXT_START',
	'SUGGESTIONS_NEXT_END'
);

// Move to the next suggestion every 5s or so.
const commenceSuggestions = () => (dispatch, getState) => {
	dispatch(actions.suggestionsStarted());

	const doNextSuggestion = () => {
		if (getState().suggestions.started) {
			dispatch(actions.suggestionsNextStart()); // Start transition to next suggestion
			setTimeout(doEndSuggestion, 2000); // Send another event after transition end
			setTimeout(doNextSuggestion, 10000);
		}
	};

	const doEndSuggestion = () =>
		getState().suggestions.started && dispatch(actions.suggestionsNextEnd());

	fetchJson('/api/community/suggestions')
		.then(communities => {
			if (getState().suggestions.started) {
				dispatch(actions.suggestionsLoaded(communities));
				setTimeout(doNextSuggestion, 10000);
			}
		})
		.catch(handleError(dispatch));
};

export default {
	...actions,
	commenceSuggestions
};



// WEBPACK FOOTER //
// ./src/profile/suggestions.actions.js